import { render, staticRenderFns } from "./MemberOrderLogistics.vue?vue&type=template&id=63f19d7e&scoped=true"
import script from "./MemberOrderLogistics.vue?vue&type=script&lang=js"
export * from "./MemberOrderLogistics.vue?vue&type=script&lang=js"
import style0 from "./MemberOrderLogistics.vue?vue&type=style&index=0&id=63f19d7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f19d7e",
  null
  
)

export default component.exports